/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { MultiWrapperComponent } from 'src/app/modules/ticket-edit/components/multi-wrapper/multi-wrapper.component';
import { TicketEditBaseComponent } from 'src/app/modules/ticket-edit/components/ticket-edit-base/ticket-edit-base.component';
import * as appStrings from '@touchplan/strings';

@Component({
	selector: 'ticket-ext-sched-id',
	templateUrl: './ticket-ext-sched-id.component.html',
	styleUrls: ['./ticket-ext-sched-id.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExternalScheduleIdComponent extends TicketEditBaseComponent implements OnInit {
	public appStrings = appStrings;

	constructor(
		@Self() @Optional() public control: NgControl,
		@Optional() public multiWrapper: MultiWrapperComponent,
		@Optional() protected cd: ChangeDetectorRef
	) {
		super(control, multiWrapper, cd);
	}

	public ngOnInit() {
		super.ngOnInit();

		this.internalField.valueChanges.pipe(takeUntil(this.shutdownSubject)).subscribe((val) => {
			this.onChange(val);
		});
	}
}
